import { useGameStore } from '../store';
import { fmt } from '../utils/format';
import { isInTossApp } from '../sdk/env';
import { openLeaderboard } from '../sdk/leaderboard';

export default function TopBar() {
  const cash    = useGameStore((s) => s.cash);
  const setShow = useGameStore((s) => s.setShow);

  const debt = cash < 0;

  // 토스 앱: 게임센터 리더보드 / 웹 개발: 자체 랭킹 화면
  const handleRanking = () => {
    if (isInTossApp()) {
      void openLeaderboard();
    } else {
      setShow('showRankScreen', true);
    }
  };

  return (
    <div id="topbar">
      <div className="game-title">청산에 살어리랏다</div>
      <div id="cash-display" className={debt ? 'debt' : undefined}>
        {fmt(cash)}냥
      </div>
      <button id="menu-btn" onClick={handleRanking} title="랭킹">
        🏆
      </button>
    </div>
  );
}
